export const styles = {
  button: {
    marginTop: '10px',
  },
}
